import Html from './Html';
import Video from './Video';

function ItemVideo({ item }) {
    return (
        <>
            {item?.video?.src && (
                <Video url={item.video.src} poster={item?.video?.poster} portrait={item?.video?.portrait}></Video>
            )}

            <h2 className="Item-title">{item?.title}</h2>

            {item?.description && (
                <div className="Item-description Text">
                    <Html html={item.description} />
                </div>
            )}

            {item?.links?.length && (
                <div className="Item-links Links">
                    {item.links.map((link, index) => (
                        <p className="Links-item" key={index}>
                            <a href={link?.url} className="Links-link">
                                {link?.title}
                            </a>
                        </p>
                    ))}
                </div>
            )}
        </>
    );
}

export default ItemVideo;
